<div class="flex gap-2">
  <textarea
    maxlength="500"
    panInput
    color="primary"
    class="flex-1 !rounded-none focus:ring-0"
    (keyup.enter)="handleAddComment()"
    placeholder="Enter comment here..."
    [(ngModel)]="content"
  ></textarea>

  <app-pan-button
    color="primary"
    icon="send"
    class="!rounded-none my-[-1px]"
    (click)="handleAddComment()"
    [disabled]="!content || addingComment"
  ></app-pan-button>
</div>
